module.exports = "<uch></uch>\r\n<head-title params='title:\"个人信息\"'></head-title>\r\n<div class=\"userContBottom\">\r\n    <div class=\"userContent\">\r\n        <user-info></user-info>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/userInfo/userInfoIndex.html
// module id = 192
// module chunks = 0